module.exports = __webpack_public_path__ + "img/puzzle5_8.c9aa5adf.jpg";